import { render, staticRenderFns } from "./SubportionsConfiguration.vue?vue&type=template&id=0a6d9fd7&"
import script from "./SubportionsConfiguration.vue?vue&type=script&lang=js&"
export * from "./SubportionsConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./SubportionsConfiguration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports